export const initialState = {
  orderIssues: []
}

export default function(state=initialState, action) {
  const { payload, type } = action

  switch(type) {
    case 'ORDER_ISSUES_LOAD_SUCCEEDED':
      return {
        ...state,
        orderIssues: payload.data
      }
    default:
      return state
  }
}
